import TranslationService from "../../services/TranslationService";
const NotificationService = require("../../services/NotificationService");

import Vue from "vue";
import { mapState } from "vuex";

export default Vue.component("accept-biozid-check", {
  props: {
    template: {
      type: String,
      default: "#vue-accept-biozid-check",
    },
  },

  data() {
    return {
      isChecked: false,
      biozidActive: false,
    };
  },

  computed: {
    ...mapState({
      showError: (state) => state.checkout.validation.biozid.showError,
    }),
  },

  created() {
    this.$nextTick(() => {
      this.init();
      this.addEventlistener();
    });

    this.$store.commit("addDynamicCheckoutValidator", { name: "biozid", validator: this.validate });
  },

  methods: {
    init() {
      if (typeof document === "undefined" || !document.body) {
        this.biozidActive = false;
        this.isChecked = true;
        this.$store.commit("setDynamicCheckoutShowError", { name: "biozid", showError: false });
        return;
      }

      this.biozidActive = document.body.classList.contains("biozid-active");

      if (!this.biozidActive) {
        this.isChecked = true;
        this.$store.commit("setDynamicCheckoutShowError", { name: "biozid", showError: false });
      } else {
        this.isChecked = false;
      }
    },

    addEventlistener() {
      if (typeof document !== "undefined") {
        document.addEventListener("biozid-active-changed", () => {
          this.init();
        });
      }
    },

    validate() {
      const showError = !this.isChecked;

      this.$store.commit("setDynamicCheckoutShowError", { name: "biozid", showError: showError });

      if (showError) {
        NotificationService.error(TranslationService.translate("MGCRedesign::Biozid.checkoutCheckAcceptBiozid"));
      }
    },
  },

  watch: {
    isChecked() {
      if (this.showError) {
        this.validate();
      }
    },
  },
});
